export default __webpack_public_path__ + "static/media/_nato.6630e7af.ico";